import { Pipe, PipeTransform } from '@angular/core';

export enum StatisticTypeEnum {
  NEW_PROJECT_CLICKED_COUNT = 0,
  COMPLUS_TTC_TOTAL = 1,
  PROJECT_SENT_COMPLUS_COUNT = 2,
  /// <summary>
  /// Comptabiliser chaque nouvelle pose
  /// </summary>
  KITCHEN_INSTALLATION_COUNT = 3,
  KITCHEN_INSTALLATION_TOTAL = 4,
  KITCHEN_INSTALLATION_TOTAL_PRODUCT = 5,
  KITCHEN_INSTALLATION_TOTAL_INSTALLATION = 6,
  /// <summary>
  /// Comptabiliser chaque nouvelle simulation
  /// </summary>
  FUNDING_COUNT = 7,
  PRINTING_COUNT = 8,
  SAVING_COUNT = 9,
  KITCHEN_WORKBENCH_CUSTOM_COUNT = 10,
  KITCHEN_WORKBENCH_SENT_COMPLUS_COUNT = 11,
  /// <summary>
  /// Comptabiliser une seule pose pour un projet même si il y a en a eu plusieurs
  /// </summary>
  KITCHEN_INSTALLATION_PER_PROJECT_COUNT = 12,
  /// <summary>
  /// Comptabiliser une seule installation pour un projet même si il y a en a eu plusieurs
  /// </summary>
  FUNDING_PER_PROJECT_COUNT = 13,
  PLANNING_NEW_RDV = 14,
  NEW_CONFIG_SAVE = 15,
  /// <summary>
  /// Comptabiliser une seule validation pour un projet même si il y a en a eu plusieurs
  /// </summary>
  VALIDATION_PER_PROJECT_COUNT = 16,
  /// <summary>
  /// nb de cartes gratuites créées depuis la pop up de création client
  /// </summary>
  NEW_FREE_CARD_RELATION_CLIENT = 17,
  /// <summary>
  /// nb de cartes payantes créées depuis la pop up de création client
  /// </summary>
  NEW_PREMIUM_CARD_RELATION_CLIENT = 18,
  /// <summary>
  /// nb de cartes gratuites créées depuis les résultats de recherche client (depuis le bouton “Souscrire”)
  /// </summary>
  NEW_FREE_CARD_RECHERCHE_CLIENT = 19,
  /// <summary>
  /// nb de cartes payantes créées depuis les résultats de recherche client (depuis le bouton “Souscrire”)
  /// </summary>
  NEW_PREMIUM_CARD_RECHERCHE_CLIENT = 20,
  /// <summary>
  /// nb de cartes gratuites créées depuis l’onglet “Validation”
  /// </summary>
  NEW_FREE_CARD_VALIDATION = 21,
  /// <summary>
  /// nb de cartes payantes créées depuis l’onglet “Validation”
  /// </summary>
  NEW_PREMIUM_CARD_VALIDATION = 22,
  /// <summary>
  /// nb de passage d’un carte gratuite à une carte payante sur l’onglet validation
  /// </summary>
  UPGRADE_PREMIUM_CARD_VALIDATION = 23,
  /// <summary>
  /// nb de cartes gratuites créées depuis la modale de CTA
  /// </summary>
  NEW_FREE_CARD_CTA = 24,
  /// <summary>
  /// nb de cartes payante créées depuis la modale de CTA
  /// </summary>
  NEW_PREMIUM_CARD_CTA = 25,
  PLANNING_CANCELLED_RDV = 26,
  /// <summary>
  ///Tutorials commencé
  /// </summary>
  TUTORIAL_START = 27,
  /// <summary>
  ///Tutorials Skipped
  /// </summary>
  TUTORIAL_SKIPPED = 28,
  /// <summary>
  ///Tutorials terminé
  /// </summary>
  TUTORIAL_FINISH = 29,
  /// <summary>
  ///Tâche crée
  /// </summary>
  TASK_NEW = 30,
  /// <summary>
  ///Tâche ouverte
  /// </summary>
  TASK_OPEN = 31,
  /// <summary>
  ///Tâche clôturée
  /// </summary>
  TASK_DONE = 32,
  /// <summary>
  /// Somme total des projets envoyé à com+ sans le montant des produits complémentaires
  /// </summary>
  KITCHEN_COMPLUS_TOTAL_WITHOUT_COMPLEMENTARY_PRODUCTS = 33,
  /// <summary>
  /// Somme total des projets comportant des produits complémentaires envoyé à com+ sans le montant des produits complémentaires
  /// </summary>
  KITCHEN_COMPLUS_PROJECT_WITH_COMPLEMENTARY_PRODUCTS_TOTAL_WITHOUT_COMPLEMENTARY_PRODUCTS = 34,
  /// <summary>
  /// Somme total des montants des produits complémentaires envoyé à com+ dans les projets comportant des produits complémenaires
  /// </summary>
  KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCTS_TOTAL = 35,
  /// <summary>
  /// Nombre total de projet envoyé à com+ ayant des produits complémentaires.
  /// </summary>
  KITCHEN_COMPLUS_PROJECT_WITH_COMPLEMENTARY_PRODUCT_COUNT = 36,
  /// <summary>
  /// Nombre total de produit complémentaire envoyé dans com+
  /// </summary>
  KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCT_COUNT = 37,
  /// <summary>
  /// Nombre total de produit complémentaire moyen envoyé dans com+
  /// </summary>
  KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCT_AVG = 38,
  /// <summary>
  /// Nombre de création de projets pose
  /// </summary>
  NEW_PREVISIT_COUNT = 39,
  /// <summary>
  /// Nombre d'envoi de PDF par mail
  /// </summary>
  EMAIL_PDF = 40,
  /// <summary>
  /// Montant moyen des projets
  /// </summary>
  AVERAGE_PROJECT_AMOUNT = 41,
  /// <summary>
  /// Nombre moyen de projets par jour
  /// </summary>
  AVERAGE_PROJECT_PER_DAY = 42,
  /// <summary>
  /// Nombre de produits dans les projets
  /// </summary>
  NB_PRODUCTS_COUNT = 43,
  /// <summary>
  /// Nombre de produits complémentaires dans les projets
  /// </summary>
  NB_COMPLEMENTARY_PRODUCTS_COUNT = 44,
  /// <summary>
  /// Nombre de clics sur le téléchargement de l'application Castomètre
  /// </summary>
  CASTOMETRE_DOWNLOAD_CLICKED_COUNT = 45,
  /// <summary>
  /// Nombre d'ouvertures des projets depuis l'accueil customer
  /// </summary>
  HOME_PROJECTS_OPENED_COUNT = 46,
  /// <summary>
  /// Nombre de fiches clients consultées dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_CUSTOMER_RECORD_OPENED_COUNT = 47,
  /// <summary>
  /// Nombre de clients créés dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_CUSTOMER_CREATED_COUNT = 48,
  /// <summary>
  /// Nombre de souscriptions avec création de carte dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_CARD_SUBSCRIPTION_COUNT = 49,
  /// <summary>
  /// Nombre de cartes upgradées dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_CARD_UPGRADED_COUNT = 50,
  /// <summary>
  /// Nombre de cartes renouvelées dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_CARD_RENEWED_COUNT = 51,
  /// <summary>
  /// Nombre de clics sur Ajouter au Wallet dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_ADD_TO_WALLET_CLICKED_COUNT = 52,
  /// <summary>
  /// Nombre de téléchargements de coupons dans Castofid Mini
  /// </summary>
  CASTOFID_MINI_COUPON_DOWNLOADED_COUNT = 53,
  /// <summary>
  /// Nombre de parcours salle de bain Kentia démarrés depuis mobile
  /// </summary>
  BATHROOM_STARTED_FROM_MOBILE_COUNT = 54,
  /// <summary>
  /// Nombre de parcours salle de bain Kentia démarrés depuis desktop
  /// </summary>
  BATHROOM_STARTED_FROM_DESKTOP_COUNT = 55,
  /// <summary>
  /// Nombre de tâches affectées à soi-même à la création
  /// </summary>
  TASK_ASSIGNED_TO_SELF_COUNT = 56,
  /// <summary>
  /// Nombre de tâches affectées à une équipe à la création
  /// </summary>
  TASK_ASSIGNED_TO_TEAM_COUNT = 57,
  /// <summary>
  /// Nombre de tâches affectées à une autre personne à la création
  /// </summary>
  TASK_ASSIGNED_TO_OTHER_VENDOR_COUNT = 58,
  /// <summary>
  /// Nombre de tâches affectées à un secteur ou sous-secteur à la création
  /// </summary>
  TASK_ASSIGNED_TO_SECTOR_SCOPE_COUNT = 59,
  /// <summary>
  /// Nombre de tâches ayant reçu au moins un commentaire
  /// </summary>
  TASK_WITH_COMMENT_COUNT = 60,
  /// <summary>
  /// Nombre moyen de commentaires par tâche
  /// </summary>
  TASK_COMMENT_AVERAGE = 61,
  /// <summary>
  /// Nombre d'ajouts réussis au panier Kingfisher
  /// </summary>
  KINGFISHER_BASKET_ADD_COUNT = 62,
  /// <summary>
  /// Quantité totale de produits ajoutés au panier Kingfisher
  /// </summary>
  KINGFISHER_BASKET_PRODUCT_QUANTITY = 63,
  /// <summary>
  /// Montant TTC total des projets ajoutés au panier Kingfisher
  /// </summary>
  KINGFISHER_BASKET_TTC_TOTAL = 64,
  /// <summary>
  /// Nombre de clics sur "Nouveau projet" pour le Panier depuis mobile
  /// </summary>
  BASKET_NEW_PROJECT_CLICKED_COUNT_MOBILE = 65,
  /// <summary>
  /// Nombre de projets Panier envoyés à COM+ depuis mobile
  /// </summary>
  BASKET_PROJECT_SENT_COMPLUS_COUNT_MOBILE = 66,
  /// <summary>
  /// Montant TTC total des projets Panier envoyés à COM+ depuis mobile
  /// </summary>
  BASKET_COMPLUS_TTC_TOTAL_MOBILE = 67,
  /// <summary>
  /// Montant moyen des projets Panier envoyés depuis mobile (dérivé, non stocké)
  /// </summary>
  BASKET_AVERAGE_PROJECT_AMOUNT_MOBILE = 68,
  /// <summary>
  /// Nombre moyen de projets Panier envoyés par jour depuis mobile (dérivé, non stocké)
  /// </summary>
  BASKET_AVERAGE_PROJECT_PER_DAY_MOBILE = 69,
  /// <summary>
  /// Nombre de clics sur "Nouveau projet" pour le Panier depuis desktop
  /// </summary>
  BASKET_NEW_PROJECT_CLICKED_COUNT_DESKTOP = 70,
  /// <summary>
  /// Nombre de projets Panier envoyés à COM+ depuis desktop
  /// </summary>
  BASKET_PROJECT_SENT_COMPLUS_COUNT_DESKTOP = 71,
  /// <summary>
  /// Montant TTC total des projets Panier envoyés à COM+ depuis desktop
  /// </summary>
  BASKET_COMPLUS_TTC_TOTAL_DESKTOP = 72,
  /// <summary>
  /// Montant moyen des projets Panier envoyés depuis desktop (dérivé, non stocké)
  /// </summary>
  BASKET_AVERAGE_PROJECT_AMOUNT_DESKTOP = 73,
  /// <summary>
  /// Nombre moyen de projets Panier envoyés par jour depuis desktop (dérivé, non stocké)
  /// </summary>
  BASKET_AVERAGE_PROJECT_PER_DAY_DESKTOP = 74,
}

@Pipe({
  name: 'statisticName',
})
export class StatisticNamePipe implements PipeTransform {
  transform(value: StatisticTypeEnum): string {
    const statisticNames = {
      [StatisticTypeEnum.NEW_PROJECT_CLICKED_COUNT]: 'Nombre de clics sur "Nouveau projet"',
      [StatisticTypeEnum.PROJECT_SENT_COMPLUS_COUNT]: 'Nombre de projets envoyés à COM+',
      [StatisticTypeEnum.KITCHEN_INSTALLATION_COUNT]: 'Nombre de simulation de chiffrage de pose (unique)',
      [StatisticTypeEnum.KITCHEN_INSTALLATION_TOTAL]: 'Somme totale de simulations de chiffrage de projet',
      [StatisticTypeEnum.KITCHEN_INSTALLATION_TOTAL_INSTALLATION]: 'Somme totale de chiffrage de pose',
      [StatisticTypeEnum.KITCHEN_INSTALLATION_TOTAL_PRODUCT]: 'Somme totale de chiffrage de produit',
      [StatisticTypeEnum.FUNDING_COUNT]: 'Nombre de simulations de financement (unique)',
      [StatisticTypeEnum.PRINTING_COUNT]: "Nombre d'impressions total",
      [StatisticTypeEnum.SAVING_COUNT]: 'Nombre de sauvegardes de projet',
      [StatisticTypeEnum.KITCHEN_WORKBENCH_CUSTOM_COUNT]: 'Nombre de projets plan de travail sur mesure démarrés',
      [StatisticTypeEnum.KITCHEN_WORKBENCH_SENT_COMPLUS_COUNT]:
        'Nombre de projets plan de travail sur mesure envoyés dans COM+',
      [StatisticTypeEnum.KITCHEN_INSTALLATION_PER_PROJECT_COUNT]: 'Nombre de simulations de chiffrage de pose (projet)',
      [StatisticTypeEnum.FUNDING_PER_PROJECT_COUNT]: 'Nombre de simulations financement (projet)',
      [StatisticTypeEnum.PLANNING_NEW_RDV]: 'Nombre de RDV créés',
      [StatisticTypeEnum.PLANNING_CANCELLED_RDV]: 'Nombre de RDV annulés',
      [StatisticTypeEnum.NEW_CONFIG_SAVE]: 'Nouvelle configuration 3D',
      [StatisticTypeEnum.VALIDATION_PER_PROJECT_COUNT]: 'Nombre de validation (projet)',
      [StatisticTypeEnum.NEW_FREE_CARD_RECHERCHE_CLIENT]:
        'Nombre de cartes gratuites créées depuis les résultats de recherche client (depuis le bouton “Souscrire”)',
      [StatisticTypeEnum.NEW_FREE_CARD_RELATION_CLIENT]:
        'Nombre de cartes gratuites créées depuis la pop up de création client',
      [StatisticTypeEnum.NEW_FREE_CARD_VALIDATION]: 'Nombre de cartes gratuites créées depuis l’onglet “Validation”',
      [StatisticTypeEnum.NEW_PREMIUM_CARD_RECHERCHE_CLIENT]:
        'Nombre de cartes payantes créées depuis les résultats de recherche client (depuis le bouton “Souscrire”)',
      [StatisticTypeEnum.NEW_PREMIUM_CARD_RELATION_CLIENT]:
        'Nombre de cartes payantes créées depuis la pop up de création client',
      [StatisticTypeEnum.NEW_PREMIUM_CARD_VALIDATION]: 'Nombre de cartes payantes créées depuis l’onglet “Validation”',
      [StatisticTypeEnum.UPGRADE_PREMIUM_CARD_VALIDATION]:
        'Nombre de passage d’un carte gratuite à une carte payante sur l’onglet validation',
      [StatisticTypeEnum.NEW_FREE_CARD_CTA]: 'Nombre de cartes gratuites créées depuis la pop-up avant la validation',
      [StatisticTypeEnum.NEW_PREMIUM_CARD_CTA]: 'Nombre de cartes payantes créées depuis la pop-up avant la validation',
      [StatisticTypeEnum.TASK_NEW]: 'Nombre de tâche crées',
      [StatisticTypeEnum.TASK_OPEN]: 'Nombre de tâche ouvertes',
      [StatisticTypeEnum.TASK_DONE]: 'Nombre de tâche clôturées',
      [StatisticTypeEnum.TASK_ASSIGNED_TO_SELF_COUNT]: 'Nombre de tâches affectées à soi-même à la création',
      [StatisticTypeEnum.TASK_ASSIGNED_TO_TEAM_COUNT]: 'Nombre de tâches affectées à une équipe à la création',
      [StatisticTypeEnum.TASK_ASSIGNED_TO_OTHER_VENDOR_COUNT]:
        'Nombre de tâches affectées à une autre personne à la création',
      [StatisticTypeEnum.TASK_ASSIGNED_TO_SECTOR_SCOPE_COUNT]:
        'Nombre de tâches affectées à un secteur ou sous-secteur à la création',
      [StatisticTypeEnum.TASK_WITH_COMMENT_COUNT]: 'Nombre de tâches avec commentaire',
      [StatisticTypeEnum.TASK_COMMENT_AVERAGE]: 'Nombre moyen de commentaires par tâche',
      [StatisticTypeEnum.KITCHEN_COMPLUS_TOTAL_WITHOUT_COMPLEMENTARY_PRODUCTS]:
        'Somme totale des projets envoyés à COM+ (hors produits complémentaires)',
      [StatisticTypeEnum.KITCHEN_COMPLUS_PROJECT_WITH_COMPLEMENTARY_PRODUCTS_TOTAL_WITHOUT_COMPLEMENTARY_PRODUCTS]:
        'Somme totale des projets avec produits complémentaires envoyés à COM+ (hors produits complémentaires)',
      [StatisticTypeEnum.KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCTS_TOTAL]:
        'Somme totale des produits complémentaires envoyés à COM+',
      [StatisticTypeEnum.KITCHEN_COMPLUS_PROJECT_WITH_COMPLEMENTARY_PRODUCT_COUNT]:
        'Nombre de projets envoyés à COM+ avec produits complémentaires',
      [StatisticTypeEnum.KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCT_COUNT]:
        'Nombre total de produit complémentaires envoyés à COM+',
      [StatisticTypeEnum.KITCHEN_COMPLUS_COMPLEMENTARY_PRODUCT_AVG]:
        'Nombre moyen de produit complémentaire envoyés à COM+',
      [StatisticTypeEnum.EMAIL_PDF]: "Nombre d'envoi de PDF par mail",
      [StatisticTypeEnum.AVERAGE_PROJECT_AMOUNT]: 'Montant moyen des projets',
      [StatisticTypeEnum.AVERAGE_PROJECT_PER_DAY]: 'Nombre moyens de projets par jour',
      [StatisticTypeEnum.NB_PRODUCTS_COUNT]: 'Nombre de produits ajoutés au panier',
      [StatisticTypeEnum.NB_COMPLEMENTARY_PRODUCTS_COUNT]: 'Nombre de produits complémentaires ajoutés au panier',
      [StatisticTypeEnum.CASTOMETRE_DOWNLOAD_CLICKED_COUNT]:
        "Nombre de clics sur le téléchargement de l'application Castomètre",
      [StatisticTypeEnum.HOME_PROJECTS_OPENED_COUNT]: "Nombre d'ouvertures des projets depuis l'accueil customer",
      [StatisticTypeEnum.CASTOFID_MINI_CUSTOMER_RECORD_OPENED_COUNT]:
        'Nombre de fiches clients consultées dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_CUSTOMER_CREATED_COUNT]: 'Nombre de clients créés dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_CARD_SUBSCRIPTION_COUNT]:
        'Nombre de souscriptions avec création de carte dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_CARD_UPGRADED_COUNT]: 'Nombre de cartes upgradées dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_CARD_RENEWED_COUNT]: 'Nombre de cartes renouvelées dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_ADD_TO_WALLET_CLICKED_COUNT]:
        'Nombre de clics sur “Ajouter au Wallet” dans Castofid Mini',
      [StatisticTypeEnum.CASTOFID_MINI_COUPON_DOWNLOADED_COUNT]:
        'Nombre de téléchargements de coupons dans Castofid Mini',
      [StatisticTypeEnum.COMPLUS_TTC_TOTAL]: 'Total TTC envoyé à COM+',
      [StatisticTypeEnum.BATHROOM_STARTED_FROM_MOBILE_COUNT]:
        'Nombre de parcours salle de bain Kentia démarrés depuis mobile',
      [StatisticTypeEnum.BATHROOM_STARTED_FROM_DESKTOP_COUNT]:
        'Nombre de parcours salle de bain Kentia démarrés depuis desktop',
      [StatisticTypeEnum.KINGFISHER_BASKET_ADD_COUNT]: "Nombre d'ajouts réussis au panier Kingfisher",
      [StatisticTypeEnum.KINGFISHER_BASKET_PRODUCT_QUANTITY]:
        'Quantité totale de produits ajoutés au panier Kingfisher',
      [StatisticTypeEnum.KINGFISHER_BASKET_TTC_TOTAL]: 'Montant TTC total des projets ajoutés au panier Kingfisher',
      [StatisticTypeEnum.BASKET_NEW_PROJECT_CLICKED_COUNT_MOBILE]:
        'Nombre de clics sur "Nouveau projet" (Mobile)',
      [StatisticTypeEnum.BASKET_PROJECT_SENT_COMPLUS_COUNT_MOBILE]:
        'Nombre de projets envoyés à COM+ (Mobile)',
      [StatisticTypeEnum.BASKET_COMPLUS_TTC_TOTAL_MOBILE]: 'Total TTC envoyé à COM+ (Mobile)',
      [StatisticTypeEnum.BASKET_AVERAGE_PROJECT_AMOUNT_MOBILE]: 'Montant moyen des projets (Mobile)',
      [StatisticTypeEnum.BASKET_AVERAGE_PROJECT_PER_DAY_MOBILE]: 'Nombre moyen de projets par jour (Mobile)',
      [StatisticTypeEnum.BASKET_NEW_PROJECT_CLICKED_COUNT_DESKTOP]:
        'Nombre de clics sur "Nouveau projet" (Desktop)',
      [StatisticTypeEnum.BASKET_PROJECT_SENT_COMPLUS_COUNT_DESKTOP]:
        'Nombre de projets envoyés à COM+ (Desktop)',
      [StatisticTypeEnum.BASKET_COMPLUS_TTC_TOTAL_DESKTOP]: 'Total TTC envoyé à COM+ (Desktop)',
      [StatisticTypeEnum.BASKET_AVERAGE_PROJECT_AMOUNT_DESKTOP]: 'Montant moyen des projets (Desktop)',
      [StatisticTypeEnum.BASKET_AVERAGE_PROJECT_PER_DAY_DESKTOP]: 'Nombre moyen de projets par jour (Desktop)',
    };
    return statisticNames[value] || 'Inconnu'; // Retourne un texte par défaut si la clé n'est pas trouvée
  }
}
